exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect[data-v-f540e34c] {\n  --bg-opacity: 1 !important;\n  background-color: #fff !important;\n  background-color: rgba(255, 255, 255, var(--bg-opacity)) !important;\n}\n", ""]);

// exports
